





























































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Emit, Mixins } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import { Route } from "vue-router";
import actions from "../../store/constants";
import BackgroundCurtainsAnimation from "../../mixins/BackgroundCurtainsAnimation";
import constants from '../../store/constants';

@Component
export default class ObjectPagePlan extends Mixins(BackgroundCurtainsAnimation) {
  @Prop() visibleScreenNumber!: number;
  @Prop() activeScreenNumber!: number;
  @Prop() screenNumber!: number;
  @State(state => state.app.loadingScreenAnimationEnded) loadingAnimationEnded!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  deactive = true;
  currentView = "front-day";
  planShowed = false;
  animating = false;

  $refs!: {
    root: HTMLElement;
    prevFocusButton: HTMLElement;
    nextFocusButton: HTMLElement;
    image: HTMLElement;
    bg: HTMLElement;
    bgWrap: HTMLElement;
    gImage: HTMLElement;
    plan: HTMLElement;
    imagesWrapper: HTMLElement;
  };

  @Emit("change-screen")
  changeScreen() { }

  mounted() {
    if (!this.scrollingByScreens) {
      this.$refs.bg.style.opacity = "1";
      this.setWidthToCurtains();
      let shadows = this.$refs.root.querySelectorAll(".shadow");
      shadows.forEach(shadow => {
        (shadow as HTMLElement).style.opacity = "1";
      });
    }
  }

  get screenHeight() {
    return (this.scrollingByScreens) ? this.$browser.height :
      (this.$browser.width < 1200) ?
        this.$browser.width * 0.70 : this.$browser.height;
  }

  @Watch("$browser.width")
  widthChange() {
    if (this.activeScreenNumber === this.screenNumber || !this.scrollingByScreens) {
      this.setWidthToCurtains();
    }
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/

  alreadyEntered = false;

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (prevNumber == this.screenNumber && this.scrollingByScreens) {
      this.screenLeave();
      this.bgLeave((nextNumber == 1) ? true : false);
    }

    if (nextNumber == this.screenNumber && (this.scrollingByScreens || !this.alreadyEntered)) {
      let bordersFront = this.$refs.root.querySelectorAll<HTMLElement>(".house-borders__front g");
      bordersFront.forEach(border => {
        border.setAttribute("style", "");
        border.classList.remove("active");
      });

      let bordersBack = this.$refs.root.querySelectorAll<HTMLElement>(".house-borders__back g");
      bordersBack.forEach(border => {
        border.setAttribute("style", "");
        border.classList.remove("active");
      });

      this.bgEnter((prevNumber == 1) ? true : false);
    }
  }


  /** Следующий экран появляется*/
  @Watch("visibleScreenNumber")
  visibleScreenNumberChange(nextNumber: number, prevNumber: number) {
    if (nextNumber == this.screenNumber && (this.scrollingByScreens || !this.alreadyEntered)) {
      this.screenEnter(prevNumber);
      this.alreadyEntered = true;
    }

    if (nextNumber == this.screenNumber) {
      localStorage.setItem("screen", "Ген. план");
    }
  }


  /** Появление */
  screenEnter(prevScreenNumber: number) {
    this.deactive = false;
    let borderSvgs = this.$refs.root.querySelectorAll<HTMLElement>(".house-borders-svg__front, .house-borders-svg__back");

    setTimeout(() => {
      borderSvgs.forEach(svg => {
        svg.style.opacity = "0";
        svg.style.display = "block";
      });
    }, 400);

    setTimeout(() => {
      this.activateHouseBorders();
    }, 520);
  }


  /** Исчезание */
  screenLeave() {
    this.deactive = true;

    let borders = this.$refs.root.querySelectorAll<HTMLElement>(".house-borders__front g, .house-borders__back g");
    let bordersSvg = this.$refs.root.querySelectorAll<HTMLElement>(".house-borders-svg__front, .house-borders-svg__back");

    borders.forEach(border => {
      anime.remove(border);
    });

    bordersSvg.forEach(bordersSvg => {
      bordersSvg.style.display = "none";
    });

    setTimeout(() => {
      this.$refs.bg.style.opacity = "0";
    }, 1500);

    setTimeout(() => {
      this.changeScreen();
    }, 650);
  }


  bgEnter(parallax: boolean) {
    if (this.scrollingByScreens) {
      this.$refs.bg.style.opacity = "1";
      if (parallax) {
        this.setWidthToCurtains();
        this.$refs.gImage!.style.transform = `translate3d(0, -50%, 0)`;
        this.$refs.bgWrap!.style.transform = `translate3d(0, 100%, 0)`;
        let transition = { value1: 0, value2: 1, value3: 0, value4: 100, value5: 50 };

        anime({
          targets: transition,
          duration: 1000,
          easing: "easeInOutQuad",
          value1: 100,
          value2: 0,
          value3: 1,
          value4: 0,
          value5: 0,
          update: () => {
            this.$refs.gImage!.style.transform = `translate3d(0, -${transition.value5}%, 0)`;
            this.$refs.bgWrap!.style.transform = `translate3d(0, ${transition.value4}%, 0)`;
          }
        });
      }
      else {
        this.$refs.gImage!.style.transform = `translate3d(0, 0%, 0)`;
        this.$refs.bgWrap!.style.transform = `translate3d(0, 0%, 0)`;
        this.curtainsEnterAnimation();
      }
    }
  }


  bgLeave(parallax: boolean) {
    this.$refs.gImage!.style.transform = `translate3d(0, 0%, 0)`;
    this.$refs.bgWrap!.style.transform = `translate3d(0, 0%, 0)`;
    if (parallax) {
      this.setWidthToCurtains();
      let transition = { value1: 0, value2: 1, value3: 0, value4: 100, value5: 0 };

      anime({
        targets: transition,
        duration: 1000,
        easing: "easeInOutQuad",
        value1: 100,
        value2: 0,
        value3: 1,
        value4: 0,
        value5: 50,
        update: () => {
          this.$refs.gImage!.style.transform = `translate3d(0, -${transition.value5}%, 0)`;
          this.$refs.bgWrap!.style.transform = `translate3d(0, ${transition.value1}%, 0)`;
        }
      });
    } else {
      this.curtainsLeaveAnimation();
    }
  }


  activateHouseBorders() {
    let bordersSvg = this.$refs.root.querySelector<HTMLElement>((this.currentView.indexOf("front") > -1)
      ? ".house-borders-svg__front" : ".house-borders-svg__back");
    let borders = this.$refs.root.querySelectorAll<HTMLElement>((this.currentView.indexOf("front") > -1)
      ? ".house-borders__front g" : ".house-borders__back g");

    borders.forEach(border => {
      border.querySelector("path")!.setAttribute("style", "");
      border.classList.remove("active");
      border.querySelector<HTMLElement>("image:nth-of-type(1)")!.style.opacity = "0";

      let promoLabel = border.querySelector<HTMLElement>(".promo-label");
      if (promoLabel) border.querySelector<HTMLElement>(".promo-label")!.style.opacity = "0";
    });

    bordersSvg!.setAttribute("style", "");

    setTimeout(() => {
      for (let index = 0; index < borders.length; index++) {
        const border = borders[index];
        let promoLabel = border.querySelector<HTMLElement>(".promo-label");

        if (promoLabel) {
          anime({
            targets: promoLabel,
            opacity: [0, 1],
            delay: () => {
              return 200 * index
            },
            duration: 500,
            easing: "easeOutQuad"
          });
        }

        anime({
          targets: border.querySelector("image:nth-of-type(1)"),
          opacity: [0, 1],
          translateY: [-30, 0],
          delay: () => {
            return 200 * index
          },
          duration: 700,
          easing: "easeOutQuad"
        });

        anime({
          targets: border.querySelector("path"),
          fill: [
            { value: "rgba(191, 194, 86, 0)" },
            { value: "rgba(191, 194, 86, 0.5)", duration: 600, easing: "easeOutQuad" },
            { value: "rgba(191, 194, 86, 0)", duration: 350, easing: "easeInQuad" }],
          stroke: [
            { value: "rgb(180, 182, 159, 0)" },
            { value: "rgba(180, 182, 159, 1)", duration: 500, easing: "easeOutQuad" },
            { value: "rgba(180, 182, 159, 1)", duration: 500 }
          ],
          delay: () => {
            return 200 * index
          },
          complete: () => {
            border.classList.add("active");
            border.querySelector("path")!.setAttribute("style", "");
          }
        });
      }
    }, 50);
  }


  get night(): boolean {
    return this.currentView.includes('night');
  }


  changeTime() {
    if (!this.animating) {
      this.animating = true;
      let nextImage = null;

      switch (this.currentView) {
        case "front-day":
          this.currentView = "front-night";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-front-night");
          break;

        case "front-night":
          this.currentView = "front-day";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-front-day");
          break;

        case "back-day":
          this.currentView = "back-night";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-back-night");
          break;

        case "back-night":
          this.currentView = "back-day";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-back-day");
          break;

        default:
          break;
      }
      nextImage!.style.display = "block";
      nextImage!.style.opacity = "0";
      this.moveImageToFront(nextImage!);

      anime({        targets: nextImage!, opacity: 1, duration: 1200, delay: 50, complete: () => {
          this.animating = false;
        }, easing: "easeOutQuad"
      });
    }
  }


  getAround() {
    if (!this.animating) {
      this.animating = true;

      let borderSvgs = this.$refs.root.querySelectorAll<HTMLElement>(".house-borders-svg__front, .house-borders-svg__back");
      let activeImage = this.$refs.root.querySelector<HTMLElement>(".image-g .active, .image-g .active-without-flip");
      let nextImage = activeImage;

      borderSvgs.forEach(svg => {
        svg!.style.display = "none";
      });

      switch (this.currentView) {
        case "front-day":
          this.currentView = "back-day";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-back-day");
          break;

        case "front-night":
          this.currentView = "back-night";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-back-night");
          break;

        case "back-day":
          this.currentView = "front-day";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-front-day");
          break;

        case "back-night":
          this.currentView = "front-night";
          nextImage = this.$refs.root.querySelector<HTMLElement>(".image-g .image-plan-front-night");
          break;

        default:
          break;
      }

      anime.remove(this.$refs.imagesWrapper);
      (anime as any).set(nextImage, { display: "block" });
      (anime as any).set(nextImage, { opacity: "0" });
      (anime as any).set(this.$refs.imagesWrapper, { perspective: "6000px" });
      (anime as any).set(this.$refs.imagesWrapper, { rotateY: "0deg" });
      this.moveImageToFront(nextImage!);

      setTimeout(() => {
        let tl = anime.timeline({ autoplay: true });
        tl.complete = () => {
          this.activateHouseBorders();
          this.animating = false;
        }

        let rotateTransition = { value: 0, value2: 180 };

        tl.add({ targets: this.$refs.imagesWrapper, scale: 0.7, duration: 500, easing: "easeOutCubic" });
        tl.add({          targets: rotateTransition, value: -180, value2: 0, duration: 1500, easing: "easeOutCubic",
          update: () => {
            let angle = ((rotateTransition.value < -90) ? rotateTransition.value2 : rotateTransition.value);
            (anime as any).set(this.$refs.imagesWrapper, { rotateY: angle + "deg" });
            if (rotateTransition.value < -89) {
              nextImage!.style.opacity = "1";
            }
          },
        }, "-=100");
        tl.add({ targets: this.$refs.imagesWrapper, scale: 1, duration: 500, easing: "easeOutCubic" }, 1650);
      }, 100);
    }
  }


  showHidePlan() {
    if (this.planShowed) {
      this.$refs.plan.style.pointerEvents = "none";
      anime({
        targets: this.$refs.plan,
        opacity: 0,
        duration: 1200,
        easing: "easeOutQuad"
      });
      this.planShowed = false;
    } else {
      this.$refs.plan.style.pointerEvents = "all";
      anime({
        targets: this.$refs.plan,
        opacity: 1,
        duration: 1200,
        easing: "easeOutQuad"
      });
      this.planShowed = true;
    }
  }


  planClick(number: number) {
    this.$store.dispatch(constants.changeActiveHouseInformationWindow, number);
  }

  moveImageToFront(image: HTMLElement) {
    let parent = image.parentElement;
    parent!.removeChild(image);
    parent!.appendChild(image);
  }
}
